module.exports = __webpack_public_path__ + "static/media/sportAvatar__lol.399ce964.jpg";